import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { Breadcrumbs, CommonGrid, TopContainer } from '../layouts';
import {
  TopButtonArea,
  ActionFilters,
  GlobalFilter,
  SharePopup,
  DeactivatePopup,
  BigButton,
} from '../common';

import { apiDeleteCollections } from '../helpers/api';
import { useScreenSettings } from '../helpers/configureHelper';
import { DELETE_ICON } from '../constants/assetConstants';
import { usePageTitle } from '../hooks/usePageTitle';
import { useUserContext } from '../contexts/UserContext';
import { useCollections } from '../hooks/useCollections';
import InfiniteScroll from '../components/InfiniteScroll/InfiniteScroll';
import { ThumbnailContainerV2 } from '../common/ThumbnailContainerV2';
import { COMMON_TAGS_MODEL_TYPES, MODEL_TYPES } from '../constants/constants';
import { icons } from '../assets';
import CreateCollectionPopup from '../common/CreateCollectionPopup';
import { PageSearchBar } from '../common/UniversalSearchForm/UniversalSearchForm';
import PageTitle from '../common/PageTitle';
import { Outlet } from 'react-router-dom';
import FilterSideModalButton from '../common/FilterSideModalButton';
import TopContainerV2 from '../layouts/TopContainerV2';
import FooterOptions from '../layouts/FooterOptions';
import { GlobalDefaultTeamMemberFilter, GlobalSearchTagsFilter } from '../common/GlobalFilter';
import { totalItemCount } from "../helpers/jsHelper";
const { CollectionIcon } = icons;

let title = 'Collections';

export default function Collections({
  useGlobalSearch,
  noDataText = "All your collections live here!",
  cardType = 'collections',
  cardProps,
  designV2 = true,
  hideStickyHeader = null
}) {
  usePageTitle(title);
  const { currentUser } = useUserContext();
  const currentMemberId = currentUser.id;
  const { showTeamMemberFilter, defaultSortOption } = useScreenSettings(cardType);

  const requestParams = useMemo(() => ({ created_by: '' }), [currentMemberId]);
  const [showNew, setShowNew] = useState(false);

  const {
    list,
    loading,
    fetchMoreData,
    hasMore,
    total,
    hasData,

    selected,
    anySelected,
    allSelected,
    selectedList,
    toggleAll,
    toggleItem,
    refetchList,
    search,
    onSearchChange,
  } = useCollections({ requestParams, defaultSort: defaultSortOption, useGlobalSearch });

  useEffect(() => {
    // when user delete single item then I call the refetch API again.
    if (window?.$refetch) {
      refetchList();
      window.$refetch = false;
    }
  }, [list]);

  const breadcrumbs = [
    {
      label: 'Collections',
    },
  ];

  const NoDataFound = () => {
    return (
      <div className="w-100 m-auto d-flex flex-column justify-content-center align-items-center">
        <h2>{noDataText}</h2>
        <p>Easy way to organise all your models, textures and product</p>
        <p>visuals to access and share easily.</p>
        <BigButton
          className="black-btn order-lg-5 lf-btn-1 keep-text"
          buttonIcon={CollectionIcon}
          onClick={() => setShowNew(true)}
          buttonTitle="Create Collection"
        />
      </div>
    );
  };

  return (
    <CommonGrid
      sticky={hideStickyHeader ? false : true}
      hiddenTab
      className={(anySelected || allSelected) && designV2 ? 'show-action-footer' : ''}
      noDataText={search ? `You don't have any ${cardType} with "${search}" name.` : NoDataFound()}
      {...(designV2 && !useGlobalSearch
        ? {
            topContainer: (
              <TopContainerV2
                hiddenTab
                globalFilter={
                  !useGlobalSearch && (
                    <div>
                      <GlobalFilter designV2 />
                      <GlobalSearchTagsFilter designV2={designV2} />
                      <GlobalDefaultTeamMemberFilter designV2 />
                    </div>
                  )
                }>
              <>
              
                  {!useGlobalSearch && (
                    <>
                      <Breadcrumbs fullWidth list={breadcrumbs} />
                      <BigButton
                        className="black-btn order-lg-5 lf-btn-1 keep-text"
                        buttonIcon={CollectionIcon}
                        onClick={() => setShowNew(true)}
                        buttonTitle="Create Collection"
                      />
                    </>
                )}
                  {!useGlobalSearch && (
                    <>
                    <div className="totalCount">{totalItemCount(total)}</div>
                      <PageSearchBar
                        designV2
                        model={COMMON_TAGS_MODEL_TYPES.COLLECTION}
                        onSearchChange={onSearchChange}
                        search={search}
                        hideTags={true}
                      />
                      <FilterSideModalButton showTeamMemberFilter={showTeamMemberFilter} />
                      <ActionFilters showTeamMemberFilter={false} />
                    </>
                  )}
                </>
              </TopContainerV2>
            ),
          }
        : {
            topContainer: (
              <TopContainer
                title={
                  !useGlobalSearch && <PageTitle title={title} total={total} search={search} />
                }
                item={cardType}
                hasData={hasData}
                buttonArea={
                  <div style={{ display: 'flex' }}>
                    {!useGlobalSearch && (
                      <TopButtonArea
                        hasData={hasData}
                        item={cardType}
                        addNewButtonArea={
                          <BigButton
                            className="lf-btn-1"
                            buttonIcon={CollectionIcon}
                            onClick={() => setShowNew(true)}
                            buttonTitle="Create Collection"
                          />
                        }
                        topButtonList={[
                          {
                            element: DeactivatePopup,
                            bigButton: true,
                            bigBtnClass: 'lf-btn-3',
                            isPlural: true,
                            iconSrc: DELETE_ICON,
                            deleteAction: apiDeleteCollections,
                            item: cardType,
                            onSuccess: refetchList,
                            actionWord: 'delete',
                          },
                          {
                            element: SharePopup,
                            bigButton: true,
                            bigBtnClass: 'lf-btn-2',
                            onSuccess: refetchList,
                            modelType: 5,
                            selectedList,
                          },
                        ]}
                        // addNewButtonArea={null}
                        anySelected={anySelected}
                        selectedList={selectedList}
                      />
                    )}
                    {!useGlobalSearch && (
                      <FilterSideModalButton showTeamMemberFilter={showTeamMemberFilter} />
                    )}
                  </div>
                }
                searchBar={
                  !useGlobalSearch && (
                    <div className="mt-2">
                      <PageSearchBar
                        model={COMMON_TAGS_MODEL_TYPES.COLLECTION}
                        onSearchChange={onSearchChange}
                        search={search}
                        hideTags={true}
                      />
                    </div>
                  )
                }
              />
            ),
          })}
      item={cardType}
      hasData={list.length > 0 || loading}
      list={list}
      {...(!designV2 &&
        !useGlobalSearch && {
          filterArea: (
            <>
              <ActionFilters
                selectedProps={
                  list?.length > 0 && {
                    allSelected: allSelected,
                    onSelectAll: () => toggleAll(),
                  }
                }
                showTeamMemberFilter={false}
              />
              <GlobalFilter />
            </>
          ),
        })}>
      <InfiniteScroll
        dataLength={list.length}
        next={fetchMoreData}
        hasMore={hasMore}
        loading={loading}
        hasChildren={hasData}
        scrollableTarget="infiniteScroll">
        <ThumbnailContainerV2
          designV2={designV2}
          items={list}
          modelType={MODEL_TYPES.COLLECTION}
          selected={selected}
          cardProps={{
            fullWidth: true,
            onSelect: toggleItem,
            ...cardProps,
          }}
        />
      </InfiniteScroll>

      {(anySelected || allSelected) && designV2 && (
        <FooterOptions>
          <>
            <div className="selected-item">
              <ActionFilters
                selectedProps={
                  list?.length > 0 && {
                    allSelected: allSelected,
                    onSelectAll: () => toggleAll(),
                  }
                }
              />
              <span>{selectedList?.length || 0} Selected</span>
            </div>
            <div className="footer-action">
            
                <TopButtonArea
                  hasData={hasData}
                  item={cardType}
                  topButtonList={[
                    {
                      element: DeactivatePopup,
                      bigButton: true,
                      bigBtnClass: 'lf-btn-3',
                      isPlural: true,
                      iconSrc: DELETE_ICON,
                      deleteAction: apiDeleteCollections,
                      item: cardType,
                      onSuccess: refetchList,
                      actionWord: 'delete',
                    },
                    {
                      element: SharePopup,
                      bigButton: true,
                      bigBtnClass: 'lf-btn-2',
                      onSuccess: refetchList,
                      modelType: 5,
                      selectedList,
                    },
                  ]}
                  anySelected={anySelected}
                  selectedList={selectedList}
                />
             
            </div>
          </>
        </FooterOptions>
      )}

      <CreateCollectionPopup onSuccess={refetchList} showNew={showNew} setShowNew={setShowNew} />

      {!useGlobalSearch && <Outlet />}
    </CommonGrid>
  );
}
